<template>
    <div>
        <div v-if="loading">
            <div class="spinner"></div>
        </div>

        <div v-else-if="errors.length" class="alert--error" >
            <p v-for="err in errors" :key="err"> {{ err }} </p>
        </div>

        <form v-if="!loading" class="form" @submit.prevent="save">
            <slot name="header"></slot>

            <div :class="wrapperClass">
                <h3 class="first">{{$t('forms.trajectory.trajectory_info')}}</h3>

                <div class="row">
                    <div class="col-12">
                        <div class="form__item">
                            <i class="form__icon icons icon-hourglass"></i>
                            <vue-select  class="form__select" v-model="trajectory.trajectory_state" :options="states" label="name" :class="{ 'has-value': trajectory.trajectory_state }"></vue-select>
                            <label class="form__label">{{$t('forms.trajectory.trajectory_state')}}</label>
                        </div>
                    </div>
                </div>

                <div v-if="showFinishedReason" class="row">
                    <div class="col-12">
                        <div class="form__item">
                            <i class="form__icon icons icon-info"></i>
                            <input v-model="trajectory.completed_reason" class="form__input--text" type="text" :class="{ 'has-value': trajectory.completed_reason }"/>
                            <label class="form__label">{{$t('forms.trajectory.completed_reason')}}</label>
                        </div>
                    </div>
                </div>


                <div class="row">
                    <div class="col-12">
                        <div class="form__item">
                            <i class="form__icon icons icon-user"></i>
                            <vue-select  class="form__select" v-model="trajectory.counselor" :options="counselors" label="name" :class="{ 'has-value': trajectory.counselor }"></vue-select>
                            <label class="form__label">{{$t('forms.trajectory.counselor')}}</label>
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="col-12">
                        <div class="form__item">
                            <i class="form__icon icons icon-briefcase"></i>
                            <vue-select  class="form__select" v-model="trajectory.organisation" :options="organisations" label="name" :class="{ 'has-value': trajectory.organisation }"></vue-select>
                            <label class="form__label">{{$t('forms.trajectory.organisation')}}</label>
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="col-12">
                        <div class="form__item">
                            <input v-model="trajectory.registered_by" class="form__input--text" type="text" :class="{ 'has-value': trajectory.registered_by }"/>
                            <label class="form__label">{{$t('forms.trajectory.registered_by')}}</label>
                        </div>
                    </div>
                </div>

                <h3>{{$t('forms.trajectory.contact_person')}}</h3>

                <div class="row">
                    <div class="col-12">
                        <div class="form__item">
                            <i class="form__icon icons icon-user"></i>
                            <input v-model="trajectory.contact_name" class="form__input--text" type="text" :class="{ 'has-value': trajectory.contact_name }"/>
                            <label class="form__label">{{$t('forms.trajectory.contact_name')}}</label>
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="col-12">
                        <div class="form__item">
                            <i class="form__icon icons icon-phone"></i>
                            <input v-model="trajectory.contact_phone" class="form__input--text" type="text" :class="{ 'has-value': trajectory.contact_phone }"/>
                            <label class="form__label">{{$t('forms.trajectory.contact_phone')}}</label>
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="col-12">
                        <div class="form__item">
                            <i class="form__icon icons icon-envelope"></i>
                            <input v-model="trajectory.contact_email" class="form__input--text" type="text" :class="{ 'has-value': trajectory.contact_email }"/>
                            <label class="form__label">{{$t('forms.trajectory.contact_email')}}</label>
                        </div>
                    </div>
                </div>

                <h3>{{$t('forms.trajectory.period')}}</h3>
                <div class="row">
                    <div class="col-12">
                        <div class="form__item">
                            <i class="form__icon icons icon-calendar"></i>
                            <input v-model="trajectory.registration_date" class="form__input--text has-value" type="date"/>
                            <label class="form__label">{{$t('forms.trajectory.registration_date')}}</label>
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="col-12">
                        <div class="form__item">
                            <i class="form__icon icons icon-calendar"></i>
                            <input v-model="trajectory.intake_date" class="form__input--text has-value" type="date"/>
                            <label class="form__label">{{$t('forms.trajectory.intake_date')}}</label>
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="col-12">
                        <div class="form__item">
                            <input v-model="trajectory.category" class="form__input--text" type="text" :class="{ 'has-value': trajectory.category }"/>
                            <label class="form__label">{{$t('forms.trajectory.category')}}</label>
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="col-12">
                        <div class="form__item">
                            <i class="form__icon icons icon-clock"></i>
                            <input v-model="trajectory.length" class="form__input--text" type="text" :class="{ 'has-value': trajectory.length }"/>
                            <label class="form__label">{{$t('forms.trajectory.length')}}</label>
                        </div>
                    </div>
                </div>

                <div class="form__item">
                    <label class="form__top_label">{{$t('forms.trajectory.schooling')}}</label>
                    <div class="checkbox">
                        <input type="checkbox" class="checkbox__cb" id="trajectoryform__schooling" v-model="trajectory.schooling" />
                        <label for="trajectoryform__schooling" class="checkbox__label"> {{$t('common.yes')}}</label>
                    </div>
                </div>
                <div class="form__item">
                    <label class="form__top_label">{{$t('forms.trajectory.apq_taken')}}</label>
                    <div class="checkbox">
                        <input type="checkbox" class="checkbox__cb" id="trajectoryform__apq" v-model="trajectory.apq_taken" />
                        <label for="trajectoryform__apq" class="checkbox__label"> {{$t('common.yes')}}</label>
                    </div>
                </div>
            </div>

            <slot name="buttons" :isSaveDisabled="isSaveDisabled">
                <div class="form__buttons">
                    <button type="submit" class="form__button button--cta" :class="{disabled: isSaveDisabled}" :disabled="isSaveDisabled">{{$t('common.save')}}</button>
                </div>
            </slot>
        </form>
    </div>
</template>

<script>
    import Vue from 'vue';
    import { Component, Prop, Watch} from 'vue-property-decorator';
    import { Trajectory, Client, Organisation, Counselor } from '@/models';
    import { FINISHED_STATES_CODES } from '@/store/modules/trajectory-resources';


    @Component
    export default class TrajectoryForm extends Vue {

        @Prop({ type: Array | String, default() {
            return [];
        } })
        wrapperClass;

        @Prop({ type: Trajectory, default() {
            return new Trajectory();
        } })
        trajectory;

        created() {
            this.errors = [];
        }

        isSaveDisabled = false;

        @Watch('trajectory', { immediate: true, deep: true })
        onTrajectoryFromChange(tr) {
            this.isSaveDisabled = !tr.trajectory_state || !tr.trajectory_state.id ||
                                  !tr.counselor || !tr.counselor.id  ||
                                  !tr.organisation || !tr.organisation.id;
        }

        saveLoading = false;

        get loading () {
            return this.$store.state.trajectory_resources.loading || this.saveLoading;
        }

        get counselors() {
            return this.$store.state.trajectory_resources.counselors;
        }

        get organisations() {
            return this.$store.state.trajectory_resources.organisations;
        }

        get states() {
            return this.$store.state.trajectory_resources.trajectory_states;
        }

        get showFinishedReason() {
            return FINISHED_STATES_CODES.includes(this.trajectory.trajectory_state.code);
        }

        save() {
            this.errors = [];
            this.saveLoading = true;
            this.trajectory.save()
                .then(res => this.$emit('saved', res))
                .catch(
                    err => {
                        if (err.status === 422) {
                            this.errors = err.errors;
                        } else {
                            this.errors = [this.$t('common.unknown_error')];
                        }
                    })
                .then(() => this.saveLoading = false);
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/forms/dashboard/TrajectoryForm.vue